/** Registered while Main (land) is mounted so global UI (e.g. deposit alert) can open BankModal. */
let openBankModal: (() => void) | undefined

export function registerBankModalOpener(fn: () => void) {
  openBankModal = fn
}

export function unregisterBankModalOpener() {
  openBankModal = undefined
}

/** @returns true if a handler ran (modal opened). */
export function tryOpenBankModal(): boolean {
  if (!openBankModal) return false
  openBankModal()
  return true
}
